module.exports = __webpack_public_path__ + "static/img/4areaB_13.0b5fa68.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/4areaB_13.png
// module id = 1177
// module chunks = 1